export const defaultEnvironment = {
  env: 'production',
  baseUrl: 'https://selfserve.apis.rogersbank.com',
  icBaseUrl: 'https://ic.rogersbank.com',
  icCardViewerBaseUrl: 'https://cardviewer.rogersbank.com',
  icViewCardDetailsBaseUrl: 'https://ic.rogersbank.com/viewcardtermsvalidation',
  registerUrl: 'https://rbaccess.rogersbank.com/?product=ROGERSBRAND',
  webregisterUrl: 'https://rbaccess.rogersbank.com/app/forgotusername',
  coorpUserLoginUrl: 'https://rbaccess.rogersbank.com/?product=ROGERSCORP',
  REACT_APP_ADOBE_DTM_URL:
    '"https://assets.adobedtm.com/8cf1b6f99d16/ce7953ba12d7/launch-fd8580f85907.min.js',
  adobeUrl:
    '"https://assets.adobedtm.com/8cf1b6f99d16/ce7953ba12d7/launch-fd8580f85907.min.js',
  contentful: {
    host: 'cdn.contentful.com',
    space: 'r5kx3olu0gzs',
    cdk: 'crPP1qad3L1Q4RzHXtjLGCOII3_UtgCqMyguTaMJ-0U',
    environment: 'master',
    'sys.id': '5zkrDRwSBNm6KCVUqHtEKC,44aa1VYmDReHbYIP5s4KyB',
    'metadata.tags.sys.id[in]': 'dashboard',
    include: 10,
  },
  loyaltyHubLogoutUrl: 'https://selfserve.rogersbank.com',
  loyaltyHubDashboardUrl: 'https://offers.rogersbank.com',
  dynaBeaconUrl:
    'https://js-cdn.dynatrace.com/jstag/17a2d2e42ea/bf45860xtq/15d129d2ae527193_complete.js',
  dynaAppId: '62a42a92-3dbd-49ff-b009-bf24dfb98dd2',
  recaptchaSiteKey: '6Ldyg38rAAAAAAhd11o7xCCGoakn8d9xXfzfrrS1',
  linkAccUrl: 'https://www.rogers.com/consumer/profile/signin',
  brazeWeb: {
    apiKey: '2414d90b-d320-48ad-91bf-abfa61b1cc18',
    endpoint: 'sdk.iad-07.braze.com',
    enableLogging: false,
    manageServiceWorkerExternally: false,
    serviceWorkerLocation: '/service-worker.js',
    enableSdkAuthentication: true,
    safariWebsitePushId: 'web.com.rogersbank.selfserve'
  },
  // Transmit Security (Mosaic) public web client — no secret on the frontend.
  transmitSecurity: {
    clientId: '8hP-17pCXWfphNweRKMpQ',
    serverPath: 'https://api.ca.transmitsecurity.io',
  },
};

export type Environment = typeof defaultEnvironment;
